<template><div/></template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'Logout',
  async created() {
    const redirect = this.$route.query.redirect || '/';
    try {
      // use API logout if this is a user-initiated page, else clientLogout is fine
      await this.clientLogout();
    } finally {
      await this.$router.replace({ name: 'login', query: { redirect } });
    }
  },
  methods: {
    ...mapActions(['clientLogout', 'logout']),
  },
};
</script>
